import axios from 'axios'
import { IncomingMessage } from 'http'
import { HeaderName } from '@/constants/header-name'
import {
  EnterpriseIdentity,
  EnterpriseIdentityResponse,
} from '@/types/schema/api/enterprise-identity'
import {
  getEnterpriseIdentityDomain,
  isLocal,
  mapApiBaseUrl,
} from '@/utils/env'
import logger from '@/utils/logger'

// 官網公開頁不需要打白牌 api
const publicPageApiBaseUrlPattern =
  /^https:\/\/www\.(stg\.|dev\.|iro\.)?kolr\.ai\/api$/

export const getEnterpriseIdentity = async (
  req?: IncomingMessage,
): Promise<EnterpriseIdentity | null> => {
  try {
    const apiBaseUrl = mapApiBaseUrl(req?.headers.host)

    if (publicPageApiBaseUrlPattern.test(apiBaseUrl)) {
      return null
    }

    const response = await axios.get<EnterpriseIdentityResponse>(
      `${apiBaseUrl}/v2/external/enterprise-identity`,
      isLocal(req?.headers.host)
        ? {
            headers: {
              [HeaderName.EnterpriseIdentityDomain]:
                getEnterpriseIdentityDomain(),
            },
          }
        : undefined,
    )

    return response.data.data
  } catch (e) {
    logger.error(e, { ssr: true })
    return null
  }
}
